<template>
  <div v-if="isVisible" class="common-switch">
    <p v-if="label" class="switch-label">{{ label }}</p>
    <label class="switch">
      <input type="checkbox" :checked="value" @change="onChange"/>
      <span class="slider"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: "CommonSwitch",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onChange(e) {
      this.$emit("input", e.target.checked);
      this.$emit("change", e.target.checked);
    },
  }
};
</script>

<style>
.common-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  .refresh-switch-title {
    margin: 0;
    font-size: 13px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #45adff;
  }

  input:checked + .slider:before {
    transform: translateX(16px);
  }
}
</style>
